import { IAccountIsActiveLang } from '../../../types/lang'
import { EAccountIsActive } from '../../../types'

export const accountIsActiveLang: IAccountIsActiveLang = {
	account_is_active: {
		[EAccountIsActive.active]: 'Active_ua',
		[EAccountIsActive.unactive]: 'Unactive_ua',
	}
}